<template>
  <pt-previous-video-detail class="pt-previous-video-detail__withData" v-loading="loading" :value="currentVideo" @deleteVideo="toDeleteVideo"></pt-previous-video-detail>

</template>

<script>
import PtPreviousVideoDetail from './index'
export default {
  name: 'pt-previous-video-detail__withData',
  components: {
    'pt-previous-video-detail': PtPreviousVideoDetail
  },
  data () {
    return {
      loading: false,
      currentVideo: {}
    }
  },
  methods: {
    load () {
      this.loading = true
      this.$store.dispatch('getVideoDetail', this.$route.params.id).then(res => {
        this.loading = false
        this.currentVideo = res.data
      }).catch(errorMessage => {
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    toDeleteVideo (row) {
      this.$confirm(`确定要删除视频：${row.name}?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deteleVideo', row.id).then(data => {
          this.$message.success('删除成功！')
          this.loading = false
          history.go(-1)
        }).catch(err => {
          this.loading = false
          this.$message.error(err)
        })
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
